/**
 * Samtykke- og tracking-ID'er.
 *
 * BEVIDST HARDCODET — læs dette før du "forbedrer" det til et DB-opslag:
 * `site_settings.cookiebot_id` er NULL i produktion, og et tomt/fejlende opslag
 * ville fjerne cookie-banneret LYDLØST mens GTM kørte videre — dvs. tracking
 * uden samtykke. En konstant kan ikke være null, kan ikke være langsom og kan
 * ikke rammes af RLS. GTM-id'et er hardcodet af samme grund.
 *
 * Skal ID'et skiftes, kræver det en deploy — det er den rigtige afvejning for
 * to værdier der ændres ~aldrig, og hvor et tomt felt er en compliance-fejl.
 */

/**
 * Cookiebot Domain Group ID. Autoriseret til brondbykoreskole.dk + www.
 *
 * Skiftes ID'et: verificér ALTID autorisationen først — et uautoriseret ID
 * loader uc.js uden nogensinde at vise banneret (kun en console-advarsel):
 *   curl -s "https://consent.cookiebot.com/<CBID>/cc.js?referer=brondbykoreskole.dk"
 * Svaret må IKKE indeholde "not authorized".
 */
export const COOKIEBOT_ID = "9574238a-d345-4f21-ae48-e1cf1c766ac2";

/** Google Tag Manager container-ID. */
export const GTM_ID = "GTM-MVGPDXKV";

/**
 * Ruter hvor hele samtykke-/tracking-kæden springes over: intet cookie-banner
 * for personalet, ingen interne sidevisninger i GA4, intet Cookiebot-forbrug.
 */
export const TRACKING_SKIP_PREFIXES = ["/admin", "/login", "/auth"] as const;

/** True hvis pathname ligger under en af de interne ruter ovenfor. */
export function shouldSkipTracking(pathname: string): boolean {
  return TRACKING_SKIP_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
